// extracted by mini-css-extract-plugin
module.exports = {"main":"Home_main__2uIek","tabContainer":"Home_tabContainer__Ud6co","tabSelect":"Home_tabSelect__WBriK","tabContent":"Home_tabContent__bUKMS"};